<div class="flex-fill d-flex flex-column">
  <button class="ms-2 btn btn-primary nomination-assignment-toolbar" (click)="printNominationFormReport()">Print Nomination Form</button>
  @if (entities) {
    <div class="m-1 grid-fill">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        [dataSource]="entities"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="rowDoubleClick($event)"
        [columnAutoWidth]="false"
        [wordWrapEnabled]="true"
        >
        <dxi-column dataField="userName" caption="Username"></dxi-column>
        <dxi-column dataField="name" caption="Name"></dxi-column>
        <dxi-column dataField="email" caption="Email"></dxi-column>
        <dxi-column dataField="inactive" caption="InActive"></dxi-column>
        <dxi-column dataField="displayRoles" caption="Roles"></dxi-column>
        <dxi-column width="10"></dxi-column>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="user-list-grid"></dxo-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-primary nomination-assignment-toolbar" (click)="printVoteReport()">Print Ballot</button>
          <button class="btn btn-secondary" (click)="open()" [disabled]="true">New</button>
          <button class="btn btn-success ms-2" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="true">Edit</button>
          <button class="btn btn-sm btn-warning ms-2" (click)="toggleShowAll()">{{ showAll ? 'Hide Inactive' : 'Show All' }}</button>
        </div>
      </dx-data-grid>
    </div>
  }
</div>
